/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */

export type UserMemberFilter = typeof UserMemberFilter[keyof typeof UserMemberFilter];


export const UserMemberFilter = {
  All: 'All',
  UserIsMember: 'UserIsMember',
  UserNotIsMember: 'UserNotIsMember',
} as const;
